// Copy and photos for /services/3d-printing/ (PrintingServicePage.js).
// Prices are the published ones in .seo/truth.md: 3D printing from about $30
// ("From $30 to thousands"), 3D modeling and 3D scanning from $250. Anything
// else is quoted per project. Photos are Contentful files from the studio.
const photoRoot = 'https://images.ctfassets.net/dovsnf6qrcem'

const pricing = {
  printFrom: 30,
  modelingFrom: 250,
  scanningFrom: 250,
}

const typeformUrl = 'https://printaworld.typeform.com/to/Xf4KYP'

const page = {
  path: '/services/3d-printing/',
  title: `Online 3D Printing Service | Custom Prints from $${pricing.printFrom}`,
  description: `Online 3D printing service from a New York studio. Send an STL, OBJ or STEP file, or a photo. Resin, nylon, large-format and metal prints from about $${pricing.printFrom}.`,
  heading: 'Online 3D Printing Service',
  eyebrow: '3D print shop in New York · Ships to all 50 states',
  answer: `PrintAWorld is an online 3D printing service with studios in Queens and Brooklyn, New York. Send an STL, OBJ or STEP file, or a sketch or photo, and we print it in-house on our resin, FDM and metal printers, finish it if you need, and ship it to all 50 states. We make prototypes, architectural models, props and production parts, from one print to a full run, with no setup fee: projects start around $${pricing.printFrom}.`,
  hero: 'chrome',
  reviewedDate: '2026-11-03',
}

const photos = {
  chrome: {
    url: `${photoRoot}/2qVhcDIOuVkHgiLUjtCg3a/0f7ca7f3da72305256fc083aac3af12c/LAL_6513.jpg`,
    width: 3000,
    height: 1974,
    alt: 'Two 3D printed guitar-player figures, one raw white print and one chrome plated',
    title: 'Raw print and chrome finish',
    caption:
      'The same figure straight off the printer and after chrome plating.',
  },
  carFrame: {
    url: `${photoRoot}/13qMXcxU3RPgNQPCqSDTSW/a263d44046ca44f4700e9c644630cf3f/Audi_Car_Frame_3d_Print.jpg`,
    width: 2880,
    height: 1800,
    alt: 'A large 3D printed scale model of a car body frame',
    title: 'Car body frame model',
    caption: 'A large-format scale model of a car body frame.',
  },
  crab: {
    url: `${photoRoot}/4xgrmZKw1AadDMNJS9EDU1/e325f2b432f1994a87f4b6eb92f24a3c/LAL_4491.jpg`,
    width: 7360,
    height: 4912,
    alt: 'A clear resin 3D printed crab on a black background',
    title: 'Clear resin crab',
    caption: 'Printed in clear resin to show every joint of the shell.',
  },
  clocks: {
    url: `${photoRoot}/5M36mljAaoRrQhFKxYCmOA/604219cdfeb48576026fb2c92f9fc11d/LAL_4244.jpg`,
    width: 4685,
    height: 6837,
    alt: 'Two Atlas clock statues, one with a bronze patina finish and one raw white 3D print',
    title: 'Atlas clock, raw and finished',
    caption: 'A raw print beside the same statue finished in bronze patina.',
  },
  minis: {
    url: `${photoRoot}/5SSkMqZBr7qGx4AYwiOPa8/3961d57e6175cd51a0bb695f7e9571ce/_DSC8719-2.jpg`,
    width: 7250,
    height: 4816,
    alt: 'Four white resin 3D printed tabletop miniatures on round bases',
    title: 'Resin miniatures',
    caption: 'Tabletop miniatures printed in resin, ready for paint.',
  },
  prototype: {
    url: `${photoRoot}/2dVJsvmulVYBKaOC0bkOGj/514c798012a4fea1b1ea9478ed01dc23/LAL_5656.jpg`,
    width: 4912,
    height: 7360,
    alt: 'A white 3D printed product enclosure prototype',
    title: 'Product prototype',
    caption: 'An enclosure prototype printed to check fit and size.',
  },
  sculpture: {
    url: `${photoRoot}/26hi0XYAkG6zZqqiXXKG5E/405f9f24bdaa14ab0ce70260565275f7/LAL_4154.jpg`,
    width: 1200,
    height: 800,
    alt: 'Close-up of a detailed white resin 3D printed warrior sculpture',
  },
  gear: {
    url: `${photoRoot}/2i590sZlWtvyg3VMkg04WB/6067f28eff85afb0da05d5f86ed599cd/3d_printed_stainless_steel_gear.jpg`,
    width: 1200,
    height: 800,
    alt: 'A stainless steel 3D printed impeller and tag',
  },
  architecture: {
    url: `${photoRoot}/4IIenZ6VV4sQ1SgWD9GPDV/fea105901d8e02e303fff5c4f9e32e46/Somos_Resin_5.jpg`,
    width: 1200,
    height: 800,
    alt: 'A white 3D printed architectural model of a multi-level building',
  },
  figure: {
    url: `${photoRoot}/1pKmfmcrvaMhC7m7ga1BBt/72c7e7c46fc3890ee48d9ac3587aaf7d/LAL_8963.jpg`,
    width: 1500,
    height: 1000,
    alt: 'Green shopping-bag mascot figure standing on a round white base',
  },
  creature: {
    url: `${photoRoot}/1wszBnKk9nXFw8ThSLFTlw/f2959211749317d873982d2b743c7e0a/LAL_4464.jpg`,
    width: 1200,
    height: 800,
    alt: 'Glossy red creature sculpture with claws on a white base',
  },
  partScan: {
    url: `${photoRoot}/v0Y1k0nrbtEwxOrJInrVT/a9246ff2e669ef5b1bd73b1d87ebb77a/LAL_8757.jpg`,
    width: 2400,
    height: 1612,
    alt: 'A molded plastic part held in front of its blue 3D scan on screen',
  },
  dispenser: {
    url: `${photoRoot}/34bXZgGC3twZQRTeUmMYFj/28cff13f260f0a4ea2dcfd7a3e25130a/LAL_5660.jpg`,
    width: 4912,
    height: 7360,
    alt: 'A white 3D printed dispenser prototype with an open front',
  },
}

const work = ['chrome', 'carFrame', 'crab', 'clocks', 'minis', 'prototype']

// Every 3D printing page on the site. A page that ranks for 3D printing
// links to 3D printing pages, not to other services.
const services = [
  {
    path: '/services/custom-3d-printing/',
    label: 'Finished pieces',
    title: 'Custom 3D printing',
    body: 'Sanded, painted or plated prints for displays, props and gifts.',
    photo: 'clocks',
  },
  {
    path: '/services/sla-3d-printing/',
    label: 'Fine detail',
    title: 'SLA resin 3D printing',
    body: 'Smooth, detailed resin parts for figurines, jewelry and prototypes.',
    photo: 'sculpture',
  },
  {
    path: '/large-scale-3d-printing-service/',
    label: 'Big builds',
    title: 'Large-format 3D printing',
    body: 'Sculptures, props and models printed in sections, up to 6 feet and more.',
    photo: 'carFrame',
  },
  {
    path: '/services/metal-3d-printing/',
    label: 'Stainless steel',
    title: 'Metal 3D printing',
    body: 'Solid stainless-steel parts printed by selective laser melting.',
    photo: 'gear',
  },
  {
    path: '/services/architectural-3d-printing/',
    label: 'Scale models',
    title: 'Architectural 3D printing',
    body: 'Building and site models for studies, presentations and displays.',
    photo: 'architecture',
  },
  {
    path: '/services/custom-figurines/',
    label: 'People & pets',
    title: '3D printed figurines',
    body: 'Figures sculpted from your photos, printed in resin and hand painted.',
    photo: 'figure',
  },
  {
    path: '/services/3d-print-from-photo/',
    label: 'No file needed',
    title: '3D print from a photo',
    body: 'Props, replicas and statues modeled from your pictures, then printed.',
    photo: 'creature',
  },
  {
    path: '/services/3d-modeling/',
    label: `From $${pricing.modelingFrom}`,
    title: '3D modeling for printing',
    body: 'Print-ready models from sketches, photos, measurements or old files.',
    photo: 'dispenser',
  },
  {
    path: '/services/3d-scanning/',
    label: `From $${pricing.scanningFrom}`,
    title: '3D scanning and printing',
    body: 'Scan an object, then print a copy, a part or a scaled version.',
    photo: 'partScan',
  },
]

const materials = [
  {
    label: 'M1',
    title: 'Standard resin',
    body: 'High detail and a smooth surface for figurines, models and display pieces.',
  },
  {
    label: 'M2',
    title: 'Somos resin',
    body: 'An industrial resin with fine detail and a clean finish. A good choice for presentation prototypes.',
  },
  {
    label: 'M3',
    title: 'Somos WaterClear resin',
    body: 'Clear, colorless parts that look like acrylic: lenses, light covers and see-through models.',
  },
  {
    label: 'M4',
    title: 'ABS',
    body: 'A strong, tough plastic for mechanical prototypes and parts that get handled.',
  },
  {
    label: 'M5',
    title: 'Nylon PA12',
    body: 'Strong and slightly flexible, for functional parts, clips and living hinges.',
  },
  {
    label: 'M6',
    title: 'Stainless steel',
    body: 'Solid metal parts by selective laser melting, in a 250 × 250 × 300 mm build area.',
  },
]

// "At a glance" fact sheet. Comparison pages and AI answers describe shops
// by these facts, so each one is stated plainly here.
const glance = [
  [
    'Studios',
    'Glendale, Queens and Brooklyn, New York. Pickup by appointment.',
  ],
  ['Delivery', 'All 50 states, with next-day shipping available'],
  ['Production', 'In-house, in our New York studios'],
  [
    'Processes',
    'An FDM print farm, SLA resin, large-format and stainless-steel metal (SLM) 3D printing',
  ],
  [
    'Materials',
    'Standard and Somos resins, Somos WaterClear, ABS, Nylon PA12, stainless steel',
  ],
  [
    'Largest size',
    '6 feet and more, printed in sections. Metal: 250 × 250 × 300 mm.',
  ],
  ['Order size', 'One print to large production runs on our FDM print farm'],
  ['Setup fee', 'None for 3D printing'],
  [
    'Price',
    `From about $${pricing.printFrom} for a simple print from a ready file`,
  ],
  ['How you get a price', 'A written quote after a person reviews your file'],
  [
    'Turnaround',
    'Next-day printing available for many jobs, with courier delivery in NYC. Large-format builds usually take 1–2 weeks.',
  ],
  ['Files', 'STL, OBJ, STEP, STP or 3DM. No file? Photos or a sketch.'],
  [
    'Common projects',
    'Architectural and scale models, prototypes, props and displays, sculptures, trophies and production parts',
  ],
  ['Also', '3D modeling, 3D scanning, sanding, painting and metal plating'],
]

// "Where can you get something 3D printed?" The options people weigh when
// they don't own a printer.
const options = [
  {
    label: 'O1',
    title: 'A library or makerspace',
    body: 'Cheapest for small, simple parts if one near you has a printer. You usually prepare the file and run the print yourself.',
  },
  {
    label: 'O2',
    title: 'An instant-quote website',
    body: 'Upload a print-ready file and get a price automatically. Good for standard engineering parts; order minimums are common, and file repair and painting usually aren’t included.',
  },
  {
    label: 'O3',
    title: 'A 3D printing studio like ours',
    body: 'A person checks your file, helps pick the material, and can model, finish, paint or plate the part. Best for business, brand and production work: prototypes, architectural models, displays, big builds and runs.',
  },
]

// Who the service suits. AI answers sort shops by "best for", so say it.
const fit = {
  good: [
    'Brands, agencies and businesses, from one print to a production run, with no setup fee',
    'Large orders on our in-house FDM print farm',
    'Architectural and scale models for presentations, competitions and displays',
    'Rush jobs: next-day printing and courier delivery in NYC',
    'Display pieces, props and sculptures that need sanding, paint or plating',
    'Large builds, 6 feet and more',
    'Stainless-steel metal parts',
    'Projects with no 3D file yet',
  ],
  other: [
    'Hobby prints and parts you plan to resell: a professional studio costs more, so a marketplace or a hobbyist will usually be cheaper.',
    'The lowest price per gram: instant-quote websites compete on that; we compete on getting the part right.',
  ],
}

const steps = [
  {
    title: 'Send your file',
    body: 'Upload your 3D file or photos and tell us the size, quantity, material and deadline. Not sure about the material? Tell us how the part will be used.',
  },
  {
    title: 'Get a written quote',
    body: 'We check the file and reply with a price, a process and a schedule. If the file needs repair or modeling, the quote says so.',
  },
  {
    title: 'We print it',
    body: 'Once you approve the quote, we print in our New York studios and remove supports.',
  },
  {
    title: 'Finishing, if you want it',
    body: 'Sanding, priming, painting or metal plating, only when it’s in your quote.',
  },
  {
    title: 'Ship or pick up',
    body: 'We ship to all 50 states, next-day if you need it, or you pick up by appointment at the studio named in your quote.',
  },
]

const prices = [
  ['Simple print from your file', `From about $${pricing.printFrom}`],
  ['3D modeling, if there’s no file', `From $${pricing.modelingFrom}`],
  ['3D scanning, to copy an object', `From $${pricing.scanningFrom}`],
  ['Sanding, painting, plating', 'Quoted per project'],
  ['Large-format builds', 'Quoted per project'],
  ['Setup fee', 'None'],
  ['Shipping, next-day available', 'Quoted to your ZIP'],
]

const cities = [
  ['New York City', '/3d-printing-nyc/'],
  ['Baltimore', '/3d-printing-service-baltimore/'],
  ['Boston', '/3d-printing-service-boston/'],
  ['Chicago', '/3d-printing-service-chicago/'],
  ['Dallas', '/3d-printing-service-dallas/'],
  ['Houston', '/3d-printing-service-houston/'],
  ['Indianapolis', '/3d-printing-service-indianapolis/'],
  ['Las Vegas', '/3d-printing-service-las-vegas/'],
  ['Los Angeles', '/3d-printing-service-los-angeles/'],
  ['Minneapolis', '/3d-printing-service-minneapolis/'],
  ['New Jersey', '/3d-printing-service-new-jersey/'],
  ['Philadelphia', '/services/3d-printing/pennsylvania/philadelphia/'],
  ['San Antonio', '/3d-printing-service-san-antonio/'],
  ['Austin', '/services/3d-printing/texas/austin/'],
  ['San Francisco', '/3d-printing-service-san-francisco/'],
  ['San Jose', '/3d-printing-service-san-jose/'],
  ['Seattle', '/services/3d-printing/washington/seattle/'],
]

const checklist = [
  'Your 3D file (STL, OBJ, STEP, STP or 3DM), or photos and a sketch',
  'Finished size, or the scale to print at',
  'How many you need',
  'Material or finish, if you know it',
  'What the part is for',
  'Your delivery ZIP code and deadline',
]

const faqs = [
  {
    question: 'How much does a 3D printing service cost?',
    answer: `At PrintAWorld, 3D printing starts around $${pricing.printFrom} for a simple print from your file and goes up to thousands of dollars for large or finished pieces. Size, material, machine time, quantity and finishing set the price. 3D modeling starts at $${pricing.modelingFrom} if you don’t have a file. Send the file for a written quote.`,
  },
  {
    question: 'Where can I get something 3D printed?',
    answer: `If you don’t own a printer, you can use a library or makerspace, an instant-quote website, or a 3D printing studio. PrintAWorld is a studio in Queens and Brooklyn, New York: send your file or photos, get a written quote, and pick up by appointment or have it shipped to any of the 50 states. There’s no setup fee, and prints start around $${pricing.printFrom}.`,
  },
  {
    question: 'Is there a minimum order?',
    answer: `No. You can order a single print, and there’s no setup fee for 3D printing. Small jobs start around $${pricing.printFrom}, and we quote larger runs per piece.`,
  },
  {
    question: 'What files do I need for 3D printing?',
    answer:
      'Send an STL, OBJ, STEP, STP or 3DM file when you have one. Other formats and file repairs are reviewed with your quote. If the file is too big to attach, send a download link.',
  },
  {
    question: 'Can you 3D print something without a 3D model?',
    answer: `Yes. We can model it from a sketch, photos or measurements. 3D modeling starts at $${pricing.modelingFrom}, and you approve the model before we print. To copy a real object, we can 3D scan it instead.`,
  },
  {
    question: 'How long does 3D printing take?',
    answer:
      'Many jobs can be printed next day, and in New York we can send them by courier. Your written quote confirms the date; it depends on the file, size, material, quantity and finishing. Large-format builds usually take 1–2 weeks, and bigger, complex projects can take 1–2 months. Tell us your deadline when you ask for a quote.',
  },
  {
    question: 'Do you 3D print architectural models?',
    answer:
      'Yes. We print building, site and interior models at the scale you need, for presentations, competitions and displays. Large models are printed in sections and assembled, and finishing is quoted with the model. Send an STL or OBJ file with the scale or finished size. See architectural 3D printing for details.',
  },
  {
    question: 'Can you 3D print large objects?',
    answer:
      'Yes. We print large sculptures, props and models in sections and assemble them; finished projects have reached 6 feet and more. Large orders run on our in-house FDM print farm. See large-format 3D printing for details.',
  },
  {
    question: 'Can you 3D print in color?',
    answer:
      'Most prints come out in one solid color. Full color comes from painting, a finishing step we quote with your project.',
  },
  {
    question: 'Can you 3D print metal?',
    answer:
      'Yes, in stainless steel, by selective laser melting, in a 250 × 250 × 300 mm build area. For gold, silver or bronze looks, we print in resin and add metal plating, which coats the surface; the part isn’t solid metal.',
  },
  {
    question: 'Do you ship 3D prints?',
    answer:
      'Yes, to all 50 states, and next-day shipping is available once your print is ready. You can also pick up by appointment at the New York studio named in your quote.',
  },
]

module.exports = {
  pricing,
  typeformUrl,
  page,
  photos,
  work,
  services,
  materials,
  glance,
  options,
  fit,
  steps,
  prices,
  cities,
  checklist,
  faqs,
}
